import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { httpPost } from "../../services/httpService";
import { addPharmacyNotificationUrl } from "../../apiUrls/apiUrls";
import { logErrorWithPayload } from "../../services/logService";

const initialState = {
  isPharmacyNotificationsLoading: false,
  isPharmacyNotificationAddLoading: false,
  isPharmacyNotificationAdded: false,
};

export const addPharmacyNotificationData = createAsyncThunk(
  "PharmacyNotifications/addPharmacyNotificationData",
  async (data) => {
    const url = addPharmacyNotificationUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);

const pharmacyNotificationsSlice = createSlice({
  name: "pharmacyNotifications",
  initialState,
  reducers: {
    setIsPharmacyNotificationsLoadingData: (state, action) => {
      state.isPharmacyNotificationsLoading = action?.payload || false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addPharmacyNotificationData.pending, (state) => {
        state.isPharmacyNotificationAddLoading = true;
      })
      .addCase(addPharmacyNotificationData.fulfilled, (state, action) => {
        state.isPharmacyNotificationAddLoading = false;
        state.isPharmacyNotificationAdded = action?.payload;
      })
      .addCase(addPharmacyNotificationData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isPharmacyNotificationAddLoading = false;
      });
  },
});

export const { setIsPharmacyNotificationsLoadingData } =
  pharmacyNotificationsSlice.actions;

export default pharmacyNotificationsSlice.reducer;
